import { Reducer } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'
import { CercState, CercTypes } from './types'

// toolkit
// import { createSlice } from '@reduxjs/toolkit'

const initialState: CercState = {
    error: '',
    mensagem: '',
    pagamentos: [],
    unidadesRecebiveisSelecionadas: []
}

const reducer: Reducer<CercState> = (state = initialState, action) => {
    switch (action.type) {
        case CercTypes.ADD_PAYMENTS: {
            const newPagamentos = [...state.pagamentos]
            const newCodigoArranjo = action.payload.agendaCodigoArranjoPagemento
            const codigoArranjoAtual = state.pagamentos[0]?.agendaCodigoArranjoPagemento
            
            if(newCodigoArranjo === codigoArranjoAtual || !codigoArranjoAtual) {
                newPagamentos.push(action.payload)
            } else {
                toast.error('Você não pode fazer contratos com credenciadoras diferentes!')
            }
            return {
                ...state,
                pagamentos: newPagamentos
            }
        }

        case CercTypes.ADD_UNIDADE_RECEBIVEL: {
            const newUnidadesRecebiveis = [...state.unidadesRecebiveisSelecionadas]
            const newCredenciadora = action.payload.instituicaoCredenciadora
            const credenciadoraAtual = state.unidadesRecebiveisSelecionadas[0]?.instituicaoCredenciadora
            
            if(newCredenciadora === credenciadoraAtual || !credenciadoraAtual) {
                newUnidadesRecebiveis.push(action.payload)
            } else {
                toast.error('Você não pode fazer contratos com credenciadoras diferentes!')
            }
            return {
                ...state,
                unidadesRecebiveisSelecionadas: newUnidadesRecebiveis
            }
        }

        case CercTypes.REMOVE_PAYMENTS: {
            const id = action.payload
            const newPagamentos = [...state.pagamentos].filter(pagamento => pagamento.id !== id)

            return {
                ...state,
                pagamentos: newPagamentos
            }
        }

        case CercTypes.REMOVE_UNIDADE_RECEBIVEL: {
            const id = action.payload
            const newUnidadesRecebiveis = [...state.unidadesRecebiveisSelecionadas].filter(unidade => unidade.id !== id)

            return {
                ...state,
                unidadesRecebiveisSelecionadas: newUnidadesRecebiveis
            }
        }

        case CercTypes.DELETE_ALL_PAYMENTS: {
            return {
                ...state,
                pagamentos: []
            }
        }

        case CercTypes.DELETE_ALL_UNIDADE_RECEBIVEL: {
            return {
                ...state,
                unidadesRecebiveisSelecionadas: []
            }
        }

        case CercTypes.DELETE_ALL_PAYMENTS_OF_UR: {
            const id = action.payload
            const newPagamentos = [...state.pagamentos].filter(pagamento => pagamento.idUr !== id)

            return {
                ...state,
                pagamentos: newPagamentos
            }
        }

        default:
            return state
    }
}

export default reducer